export default __webpack_public_path__ + "static/media/cp_geo_ua.41f78cec.svg";